export default "__VITE_ASSET__CVhgM9Bv__"